import { mapState, mapActions } from 'vuex';

export default {
  name: 'Tabstrip',
  computed: {
    ...mapState('mainView', ['tabs']),
  },
  methods: {
    ...mapActions('mainView', [
      'addNewTab',
      'removeTab',
    ]),
    closeActiveTab() {
      const relativeUrl = this.path;
      const index = this.getTabIndex(relativeUrl);

      if (index > -1) this.closeTab(index);
    },
    getTabIndex(relativeUrl) {
      let index = -1;
      let tabCount = 0;
      let isTabFound = false;

      if (this.tabs) {
        while (tabCount < this.tabs.length && !isTabFound) {
          const tab = this.tabs[tabCount];

          isTabFound = tab && tab.path === relativeUrl;
          tabCount += 1;
        }
      }
      if (isTabFound) index = tabCount - 1;

      return index;
    },
    closeTab(index) {
      this.removeTab(index);

      const totalTabSize = this.tabs.length;
      const previousTab = this.tabs.find(tab => tab.path === this.previousPath);
      const hasTab = totalTabSize > 0;

      if (hasTab) {
        if (previousTab) {
          this.$router.push(previousTab.path);
        } else {
          const lastTab = this.tabs[totalTabSize - 1];
          this.$router.push(lastTab.path);
        }
      } else {
        this.$router.push('/dashboard');
      }
    },
    closeTabByPath(path) {
      const index = this.getTabIndex(path);

      if (index > -1) {
        this.closeTab(index);
      }
    },
  },
};

